module.exports = __webpack_public_path__ + "dash_icon.svg?94b9ae90fc721072b5f8199a6ab9a747";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/dash_icon.svg
// module id = 1148
// module chunks = 2